<template>
  <div class="email">
    <p class="text-h6">出向先変更</p>
    <v-row justify="center">
      <v-col
        cols="12"
        sm="10"
        md="8"
        lg="6"
      >
        <div>
          <v-form @submit.prevent v-if="!isLoading">
            <v-card tail outlined>
              <v-card-text>
                <div class="my-3">
                  出向者は、キャンペーンに参加した結果の提出先を、出向先の事業所窓口に変更することができます。未設定の場合は出向元の事業所窓口に提出されます。<br/>
                  <span class="red--text">※出向者ではない方は「出向していない」のままとしてください。</span>
                </div>
                <v-select
                  v-model="selectedSeconded"
                  :items="officeList"
                  label="出向先"
                  hide-details="auto"
                  return-object
                  outlined
                  dense
                ></v-select>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  type="submit"
                  :loading="isSubmitting"
                  @click="save"
                  class="mt-2"
                  color="primary"
                >
                  変更
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </div>
      </v-col>
    </v-row>
    <SuccessSnackbar ref="snackbar"/>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
const SuccessSnackbar = () => import('../util/SuccessSnackbar.vue')

const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      seconded_code
      seconded_name
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return {
    seconded_code: data.seconded_code,
    seconded_name: data.seconded_name
  }
}

const entryUpdateSeconded = (secondedCode) => `
  mutation updateSeconded {
    updateSeconded(
       input: {
        seconded_code: "${secondedCode.value}"
        seconded_name: "${secondedCode.text}"
      }
    )
  }
`
const updateSeconded = async (secondedCode) => {
  const { data: { updateSeconded: data } } = await GraphqlAPI(entryUpdateSeconded(secondedCode))
  return data
}

export default {
  name: 'seconded_destination',
  data () {
    return {
      officeList: [],
      selectedSeconded: {},
      isLoading: false,
      isSubmitting: false
    }
  },
  computed: {
    getCampaign () {
      return this.$store.getters.getCampaign
    }
  },
  components: {
    SuccessSnackbar
  },
  mounted () {
    this.fetchUserViewData()
    this.createOfficeSelectList()
  },
  methods: {
    async fetchUserViewData () {
      try {
        this.isLoading = true
        const userview = await getUserViewInfo(this.getCampaign.id)
        this.selectedSeconded = userview.seconded_code
          ? { text: userview.seconded_name, value: userview.seconded_code }
          : { text: '出向していない', value: 'unselected' }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.$emit('errorHandling', 'ユーザー情報の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    createOfficeSelectList () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/office_list.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            me.officeList = this.response.map(office => ({
              text: office.name,
              value: office.id
            }))
            me.officeList.unshift({ text: '出向していない', value: 'unselected' })
          }
        }
      }
    },
    async save () {
      try {
        this.isSubmitting = true
        await updateSeconded(this.selectedSeconded)
        await this.$refs.snackbar.open('出向先を更新しました。')
        this.$emit('fetchChangeSeconded', this.selectedSeconded.text)
        this.isSubmitting = false
      } catch (e) {
        this.$emit('errorHandling', '出向先の更新に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    }
  }
}
</script>
